import React, { useState, useEffect } from "react";
import "./AppNew.css";
import { useLocation, Outlet } from "react-router-dom";
import Navbar from "./components/Navbar";
import "./index.css"; // Ensure TailwindCSS is included
import Home from "./widgets/Home";
import AboutMe from "./widgets/AboutMe";
import ExperiencesNew from "./widgets/ExperienceNew";
import ProjectsNew from "./widgets/ProjectsNew";
import Myposts from "./widgets/Blogs";
import Contact from "./widgets/Contact";

const App = () => {
  const location = useLocation();
  const [selectedNav, setSelectedNav] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function to update the width
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setSelectedNav("Home");
        break;
      case "/about-me":
        setSelectedNav("About Me");
        break;
      case "/experience":
        setSelectedNav("Experience");
        break;
      case "/projects":
        setSelectedNav("Projects");
        break;
      case "/blogs":
        setSelectedNav("Blog");
        break;
      case "/gallery":
        setSelectedNav("Gallery");
        break;
      default:
        setSelectedNav("Home");
    }
  }, [location.pathname]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="relative bg-[#171918] min-h-screen">
      {!isSidebarOpen ? (
        <button
          className="block md:hidden fixed top-4 left-4 z-50"
          onClick={toggleSidebar}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6 text-white"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      ) : null}

      <div className="flex py-8 px-2 justify-center z-50">
        <div
          className={`z-50 fixed inset-y-0 left-0 transform ${
            isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out md:relative md:translate-x-0 md:flex md:flex-col ${
            width < 850 ? "w-screen" : "md:w-1/4"
          }`}
        >
          <Navbar
            className="md:fixed"
            selectedNav={selectedNav}
            setSelectedNav={setSelectedNav}
            toggleSidebar={toggleSidebar}
          />
        </div>
        <div className="flex flex-col w-full md:w-3/4 p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default App;
